import { Preferences } from '@capacitor/preferences';
const set = async (key, value) => {
  const valueIsObject = typeof value === 'object' && value !== null ? true : false;
  await Preferences.set({
    key: key,
    value: valueIsObject ? JSON.stringify(value) : value
  });
};
const get = async (key, isObject = false) => {
  const ret = await Preferences.get({
    key: key
  });
  const result = isObject && ret.value ? JSON.parse(ret.value) : ret.value;
  return result;
};
const remove = async key => {
  await Preferences.remove({
    key: key
  });
};
export { set, get, remove };